// 月次目標（目標金額）の純ロジック（2026-08-25 オーナー確定仕様）。
// settings/goals ドキュメント { months: { 'YYYY-MM': { uri, arari, shushi } } } を対象に、
// ダッシュボード3カード（総売上/粗利益/全社収支）へ達成率を出す。
//  - 締まった月: 素の達成率（ラベル「達成」）
//  - 進行中の月: 日割り按分（目標×経過日数/月日数）に対する率（ラベル「ペース」）
//  - 未来の月: 素の達成率で扱う（実績が無ければ0%）
//  - %は100を超えてそのまま。バーだけ100で止める。色は2値（>=100 pos / 未満 neg）

// 達成率。goal が無効なら null（カードに何も出さない）。
export function goalProgress(actual, goal, monthKey, todayIso, opts = {}) {
  const prorate = opts.prorate !== false // 率系の指標（実車率など）は按分しない
  const g = Number(goal)
  if (goal == null || goal === '' || isNaN(g) || g <= 0) return null
  const a = Number(actual) || 0
  const today = String(todayIso || '')
  const thisMonth = today.slice(0, 7)
  let target = g
  let label = '達成率'
  if (prorate && monthKey === thisMonth) {
    const day = Number(today.slice(8, 10)) || 1
    const y = Number(monthKey.slice(0, 4)), m = Number(monthKey.slice(5, 7))
    const daysInMonth = new Date(y, m, 0).getDate()
    target = g * day / daysInMonth
    label = 'ペース'
  }
  const pct = a / target * 100
  return { pct, label, ok: pct >= 100, barPct: Math.min(pct, 100) }
}

// 逆向き指標（少ないほど良い・赤字乗務員など）。目標「goal 以下」に対する判定。
// goal は 0 も有効（0人以下）。無効なら null。
export function goalBelow(actual, goal) {
  const g = Number(goal)
  if (goal == null || goal === '' || isNaN(g) || g < 0) return null
  const a = Number(actual) || 0
  return { ok: a <= g, over: Math.max(0, a - g) }
}

// % の表示。整数なら小数を出さない（108%）。それ以外は小数1位（96.4%）。
export function fmtGoalPct(pct) {
  const r = Math.round(Number(pct) * 10) / 10
  return (r % 1 === 0 ? String(Math.round(r)) : r.toFixed(1)) + '%'
}

// 今日の YYYY-MM-DD（ローカル時刻）。
export function todayIso() {
  const d = new Date()
  const p2 = (x) => String(x).padStart(2, '0')
  return `${d.getFullYear()}-${p2(d.getMonth() + 1)}-${p2(d.getDate())}`
}
